import { IDotTuyenSinhActionTypes } from "../../action-types/category/IDotTuyenSinhActions";
import { IDotTuyenSinhReducer } from "../../reducer-model/category/IDotTuyenSinhReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDotTuyenSinhReducer = {
  status: eReducerStatusBase.is_not_initialization,
  dotTuyenSinhs: [],
};
export const dotTuyenSinhReducer = (
  state: IDotTuyenSinhReducer = iniState,
  action: IDotTuyenSinhActionTypes
): IDotTuyenSinhReducer => {
  switch (action.type) {
    case "DOT_TUYEN_SINH_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "DOT_TUYEN_SINH_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        dotTuyenSinhs: action.payload,
      };
    case "DOT_TUYEN_SINH_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
